module.exports = __webpack_public_path__ + "img/1.674cd059.png";